import {noPropagate} from '@containers/hooks'
import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {useFileViewerStore} from '../file-viewer-store'
import IconZoomIn from '../icons/icon-zoom-in.svg'
import IconZoomOut from '../icons/icon-zoom-out.svg'

const TwIconWrapper = tw.div`
  cursor-pointer
  rounded-4
  hover:bg-project-hover-old-dark
  active:bg-main-old-dark
  select-none
  h-24
`

const TwZoomWrapper = tw.div`
  flex
  select-none
  items-center
  gap-4
  cursor-pointer
  py-4
  px-8
  rounded-4
  hover:bg-project-hover-old-dark
  active:bg-main-old-dark
  font-normal
  truncate
  leading-4
  text-14
  text-secondary-old-dark
`

export const ZoomControls = observer(() => {
  const [state] = useFileViewerStore()

  const onClickOnZoomOut = (e: React.MouseEvent) => {
    noPropagate(e)
    state.refZoom?.current?.zoomOut(0.5)
  }

  const onClickOnZoomIn = (e: React.MouseEvent) => {
    noPropagate(e)
    state.refZoom?.current?.zoomIn(0.5)
  }

  const onReset = (e: React.MouseEvent) => {
    noPropagate(e)
    state.refZoom?.current?.reset()
  }

  return (
    <div className="flex gap-12">
      <div onClick={onClickOnZoomOut}>
        <TwIconWrapper>
          <IconZoomOut className="text-secondary-old-dark" />
        </TwIconWrapper>
      </div>
      <TwZoomWrapper onClick={onReset}>
        {Math.round(state.zoom * 100)}%
      </TwZoomWrapper>
      <div onClick={onClickOnZoomIn}>
        <TwIconWrapper>
          <IconZoomIn className="text-secondary-old-dark" />
        </TwIconWrapper>
      </div>
    </div>
  )
})
